import React from "react";
import FontBody1 from "../../../../../fonts/font-body1/font-body1";
import {FONT_COLOR, FONT_VARIANT} from "../../../../../fonts/font-props";

type CurrentPortalProps = {
    portalName: string;
    secondaryPortalName?: string;
}

const CurrentPortal: React.FC<CurrentPortalProps>  = ({ portalName, secondaryPortalName }) => {
    return (
        <>
            <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{portalName}</FontBody1>
            {secondaryPortalName && <FontBody1>&nbsp;•&nbsp;{secondaryPortalName}</FontBody1>}
        </>
    )
}

export default CurrentPortal;